import React from "react";

export const SectionHeading = ({
  eyebrow,
  title,
  italicWord,
  kicker,
  light = false,
  align = "left",
  titleClassName = "",
}) => {
  const text = light ? "text-bone" : "text-ink";
  const muted = light ? "text-white/60" : "text-ink/60";
  return (
    <div className={`reveal ${align === "center" ? "text-center mx-auto" : ""} max-w-3xl`}>
      {eyebrow && <div className="text-md label-eyebrow  mb-6">{eyebrow}</div>}
      <h2 className={`heading-display ${text} text-4xl md:text-5xl lg:text-6xl ${titleClassName}`.trim()}>
        {title}
        {italicWord && <span className="italic font-light text-gold"> {italicWord}</span>}
      </h2>
      {kicker && <p className={`${muted} mt-6 max-w-xl text-base md:text-lg leading-relaxed ${align === "center" ? "mx-auto" : ""}`}>{kicker}</p>}
    </div>
  );
};
